export default __webpack_public_path__ + "static/media/logo.71796788.svg";